const styles = {
  container: { 
   
    padding: 20, 
    minHeight: "100vh", 
    backgroundColor: "#f0f2f5", 
    fontFamily: "'Inter', sans-serif" 
  },

  organisationHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '15px'
  },
  header: { 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center", 
    marginBottom: 25,
    flexWrap: 'wrap',
    gap: '15px'
  },
  title: { 
    fontSize: 28, 
    fontWeight: 700, 
    color: "#1B019B", 
    display: "flex", 
    alignItems: "center", 
    gap: 12 
  },
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '15px',
    marginBottom: '20px',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '15px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  filterIcon: {
    color: '#666',
    fontSize: '16px'
  },
  searchBar: {
    padding: '10px 15px 10px 35px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    minWidth: '250px',
    fontSize: '14px'
  },
  select: {
    padding: '10px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '14px',
    minWidth: '120px'
  },
  pageSizeLabel: {
    fontSize: '14px',
    color: '#555',
    fontWeight: '600'
  },
grid: { 
  display: "grid", 
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", 
  gap: 20,
  marginBottom: 30,
  width: "100%",
  boxSizing: "border-box"
},
  card: { 
    background: "#fff", 
    padding: 7, 
    borderRadius: 16, 
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)", 
    display: "flex", 
    flexDirection: "column",
    transition: "0.3s",
    border: "1px solid #e0e0e0",
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 16px rgba(0,0,0,0.12)'
    }
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '15px',
    paddingBottom: '15px',
    borderBottom: '1px solid #f0f0f0'
  },
  cardTitle: { 
    fontSize: 18, 
    fontWeight: 600, 
    color: "#1B019B", 
    marginBottom: 8 
  },
  cardText: { 
    color: "#555", 
    marginBottom: 6, 
    fontSize: 14 
  },
  cardActions: { 
    display: "flex", 
    justifyContent: "space-between", 
    gap: 10, 
    marginTop: 15 
  },
  entreeBtn: { 
    background: "#28a745", 
    border: "none", 
    padding: "10px 16px", 
    borderRadius: 8, 
    cursor: "pointer", 
    color: "#fff", 
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
    justifyContent: 'center',
    transition: 'background 0.2s',
    '&:hover': {
      background: "#218838"
    }
  },
  sortieBtn: { 
    background: "#dc3545", 
    border: "none", 
    padding: "10px 16px", 
    borderRadius: 8, 
    cursor: "pointer", 
    color: "#fff", 
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
    justifyContent: 'center',
    transition: 'background 0.2s',
    '&:hover': {
      background: "#c82333"
    }
  },
  tableContainer: {
    background: "#fff",
    borderRadius: 16,
    padding: 20,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    marginTop: 20
  },
  tableHeader: {
    backgroundColor: "#1B019B",
    color: "#fff"
  },
  editButton: {
    background: "#ffc107",
    border: "none",
    padding: "5px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    color: "#000",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    transition: 'background 0.2s',
    '&:hover': {
      background: "#e0a800"
    }
  },
  motifButton: {
    background: "#17a2b8",
    border: "none",
    padding: "5px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    transition: 'background 0.2s',
    '&:hover': {
      background: "#138496"
    }
  },
  photoCell: {
    textAlign: 'center',
    padding: '8px'
  },
  photo: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      transform: 'scale(1.1)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
    }
  },
  defaultPhoto: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#ddd',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalOverlay: { 
    position: "fixed", 
    top: 0, 
    left: 0, 
    width: "100vw", 
    height: "100vh", 
    backgroundColor: "rgba(0,0,0,0.5)", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    zIndex: 1000 
  },
  modalContent: {
    background: "#fff", 
    borderRadius: 16, 
    padding: 25, 
    maxWidth: 500, 
    width: "90%", 
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    textAlign: "center",
    position: 'relative'
  },
  modalImage: {
    maxWidth: '100%',
    maxHeight: '400px',
    borderRadius: '8px'
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#555'
  },
  employeeName: {
    marginTop: '10px',
    fontWeight: '600',
    color: '#1B019B'
  },
  closeBtn: { 
    position: "absolute", 
    top: 15, 
    right: 15, 
    background: "none", 
    border: "none", 
    cursor: "pointer", 
    fontSize: 20, 
    color: "#555" 
  },
  modalActions: {
    display: "flex", 
    justifyContent: "center", 
    gap: 15, 
    marginTop: 20
  },
  confirmBtn: {
    background: "#28a745", 
    border: "none", 
    padding: "10px 20px", 
    borderRadius: 8, 
    cursor: "pointer", 
    color: "#fff", 
    fontWeight: 600,
    minWidth: "100px",
    transition: 'background 0.2s',
    '&:hover': {
      background: "#218838"
    }
  },
  cancelBtn: {
    background: "#dc3545", 
    border: "none", 
    padding: "10px 20px", 
    borderRadius: 8, 
    cursor: "pointer", 
    color: "#fff", 
    fontWeight: 600,
    minWidth: "100px",
    transition: 'background 0.2s',
    '&:hover': {
      background: "#c82333"
    }
  },
  noData: { 
    textAlign: "center", 
    color: "#555", 
    marginTop: 50, 
    fontSize: 16,
    padding: '20px'
  },
  textarea: {
    width: '100%',
    minHeight: '100px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '14px',
    marginTop: '15px',
    resize: 'vertical'
  },
  inputField: {
    width: '100%',
    padding: '10px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '14px',
    marginBottom: '15px'
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    gap: '5px',
    alignItems: 'center'
  },
  paginationButton: {
    padding: '8px 12px',
    border: '1px solid #ddd',
    background: '#fff',
    cursor: 'pointer',
    borderRadius: '4px',
    transition: 'all 0.2s',
    '&:hover': {
      background: '#f8f9fa'
    }
  },
  paginationActive: {
    background: '#1B019B',
    color: '#fff',
    borderColor: '#1B019B',
    '&:hover': {
      background: '#0d0066'
    }
  },
  paginationDisabled: {
    padding: '8px 12px',
    border: '1px solid #ddd',
    background: '#f8f9fa',
    cursor: 'not-allowed',
    borderRadius: '4px',
    color: '#6c757d'
  },
  // Styles pour les périodes
  exceptionnellePeriod: {
    color: '#dc3545',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontWeight: '600'
  },
  matinPeriod: {
    color: '#fd7e14',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },
  apresMidiPeriod: {
    color: '#20c997',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },
  descentePeriod: {
    color: '#0dcaf0',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },
  pausePeriod: {
    color: '#6f42c1',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },
  defaultPeriod: {
    color: '#6c757d'
  },
  entryIcon: {
    color: '#28a745',
    marginRight: '5px'
  },
  exitIcon: {
    color: '#dc3545',
    marginRight: '5px'
  },
  tableFilters: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '15px',
    marginBottom: '20px',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '15px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },

  cardsPagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
    gap: '15px'
  },  
  
};

export default styles;